module.exports = __webpack_public_path__ + "img/p16.01414665.png";